import { render, staticRenderFns } from "./dispenseFooter.vue?vue&type=template&id=3ee993c4&scoped=true"
import script from "./dispenseFooter.vue?vue&type=script&lang=js"
export * from "./dispenseFooter.vue?vue&type=script&lang=js"
import style0 from "./dispenseFooter.vue?vue&type=style&index=0&id=3ee993c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee993c4",
  null
  
)

export default component.exports